/* Profile: the fifth tab, as drawn.
 *
 * It was folded into Settings on 2026-09-17 and put back the same day: the tab
 * bar is five, and what was thin about this screen was the parts that were
 * false, not the screen.
 *
 * WHAT THE ARTBOARD HAS THAT THIS DOES NOT, and why each one is wrong rather
 * than empty: "saved · QAR" (no reward has a riyal value), "Shops you have
 * joined · leave a programme or find a branch" (no leave route, no branch list)
 * and "Help and contact · WhatsApp a person, not a bot" (no WhatsApp).
 *
 * Every number here is one the API counts: cards held, visits that a reversal
 * has not taken back, and rewards actually taken.
 */
import { plural, t } from "@damga/kit";

import type { Card } from "../App";
import { phoneForDisplay } from "../ui";

function initials(name: string | null): string {
  if (!name) return "·";
  return name.trim().split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]!.toUpperCase()).join("");
}

export function Profile({
  name,
  phone,
  email,
  cards,
  onGoWallet,
  onGoActivity,
}: {
  name: string | null;
  phone: string;
  email: string | null;
  cards: Card[];
  onGoWallet: () => void;
  onGoActivity: () => void;
}) {
  const live = cards.filter((c) => !c.archived_at);
  const visits = live.every((c) => typeof c.visits === "number")
    ? live.reduce((n, c) => n + (c.visits ?? 0), 0)
    : null;
  const rewards = cards.every((c) => typeof c.rewards_taken === "number")
    ? cards.reduce((n, c) => n + (c.rewards_taken ?? 0), 0)
    : null;
  const shops = new Set(cards.filter((c) => (c.rewards_taken ?? 0) > 0).map((c) => c.business_id)).size;

  return (
    <>
      <section className="identity">
        <span className="avatar" aria-hidden="true">
          {initials(name)}
        </span>
        <div className="shrink">
          <p className="identity-name">{name ?? t("settings.noName")}</p>
          <p className="identity-sub">{phone ? phoneForDisplay(phone) : email ?? ""}</p>
        </div>
      </section>

      <div className="stats" data-count={visits === null ? 2 : 3}>
        <div className="stat">
          <p className="stat-v">{live.length}</p>
          <p className="stat-k">{t("home.stat.cards")}</p>
        </div>
        {visits !== null && (
          <div className="stat">
            <p className="stat-v" data-accent="">
              {visits.toLocaleString("en-GB")}
            </p>
            <p className="stat-k">{t("home.stat.visits")}</p>
          </div>
        )}
        <div className="stat">
          <p className="stat-v">{rewards === null ? "·" : rewards}</p>
          <p className="stat-k">{t("profile.stat.rewards")}</p>
        </div>
      </div>

      {/* The artboard's standing card, with a line the ledger can answer and
          without its second sentence, which was a slogan rather than a fact. */}
      <section className="standing">
        <p className="label">{t("profile.standing")}</p>
        <p className="standing-line">
          {rewards === null
            ? t("profile.standingBody")
            : `${plural("profile.rewardCount", rewards)} ${plural("profile.acrossShops", shops)}`}
        </p>
        {rewards !== null && <p className="standing-body">{t("profile.standingBody")}</p>}
      </section>

      <section className="group">
        <button type="button" className="group-row" onClick={onGoWallet}>
          <span className="shrink">
            <span className="group-row-title">{t("profile.row.cards")}</span>
            <span className="group-row-body">{t("profile.row.cardsBody")}</span>
          </span>
          <span className="group-row-end">→</span>
        </button>
        <button type="button" className="group-row" onClick={onGoActivity}>
          <span className="shrink">
            <span className="group-row-title">{t("profile.row.activity")}</span>
            <span className="group-row-body">{t("profile.row.activityBody")}</span>
          </span>
          <span className="group-row-end">→</span>
        </button>
      </section>
    </>
  );
}
